import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./dashboardTable.scss";
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TablePagination,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import {
  clearVisualizationSubmitStatus,
  getFilesDataForVisualization,
  submitForVisualization,
  getVisualizationTableName,
  addNewVisualizationTableName,
} from "../../../redux/administrator/actions";
import Header from "../../../components/Header/Header";
import SearchBar from "../../../components/Controls/SearchBar/SearchBar";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Label from "../../../components/Label/Label";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "@mui/icons-material/Add";

function validateLowerCase(input) {
  return input.toLowerCase();
}

function validateNoSpecialChars(input) {
  return input.replace(/[^a-zA-Z0-9_]/g, "");
}

function validateAndReplaceSpaces(input) {
  return input.replace(/\s+/g, "__");
}

const VisualizationDashboardTables = (props) => {
  const dispatch = useDispatch();

  // const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const submitSatatus = useSelector(
    (state) => state?.admin?.visualizationAPiStatus
  );
  const visualizationData = useSelector(
    (state) => state?.admin?.visualizationData?.data || []
  );
  const visualizationDataCount = useSelector(
    (state) => state?.admin?.visualizationData || []
  );
  const visualizationTableName = useSelector(
    (state) => state?.admin?.visualizationTableName
  );
  const [pageCount, setPageCount] = useState(
    visualizationDataCount?.total_count || 0
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clonedVisualizationData, setClonedVisualizationData] = useState([]);
  const [dataToSubmit, setDataToSubmit] = useState([]);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  // const [selectValue, setSelectValue] = useState("");
  const [selectValues, setSelectValues] = useState("");
  const [customInputValue, setCustomInputValue] = useState("");
  const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(-1);
  useEffect(() => {
    dispatch(getVisualizationTableName());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (visualizationData) {
      setClonedVisualizationData(
        visualizationData.length ? [...visualizationData] : []
      );
    }
  }, [visualizationData]);
  useEffect(() => {
    if (visualizationTableName) {
      const tableName = visualizationTableName?.map((item) => ({
        value: item?.table_name,
        label: item?.table_name,
      }));
      setMenuItems((prevMenuItems) => [...tableName]);
    }
  }, [visualizationTableName]);

  useEffect(() => {
    setPageCount(visualizationDataCount?.total_count || 0);
  }, [visualizationDataCount]);

  const handleSelectChange = (event, item, list) => {
    const value = event.target.value;
    if (value === "New") {
      setSelectedDropdownIndex(item);
    } else {
      setSelectedDropdownIndex(-1);
    }
    // setSelectValue(value);
    const updatedData = [...visualizationData];
    updatedData[item].selectValue = value;
    const newValue = { id: list.id, value: value };
    setSelectValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[item] = newValue;
      return updatedValues;
    });
    setClonedVisualizationData(updatedData);
  };

  useEffect(() => {
    if (submitSatatus && submitSatatus?.loader === false) {
      if (submitSatatus?.apiSuccess === true) {
        setSuccess(true);
        setMessage(submitSatatus?.message);
        dispatch(clearVisualizationSubmitStatus());
      } else if (submitSatatus?.apiError === true) {
        setErr(true);
        setMessage(submitSatatus?.message);
      }
    }
  }, [submitSatatus, dispatch]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
    };

    dispatch(getFilesDataForVisualization(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
    };

    dispatch(getFilesDataForVisualization(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, rowsPerPage]);

  useEffect(() => {
    dispatch(getVisualizationTableName());
  }, [dispatch]);

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      getFilesDataForVisualization({
        page: value + 1,
        page_size: rowsPerPage,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    // setPageCount(visualizationDataCount?.total_count);
  };

  const handleChange = (e, index, id) => {
    if (e.target.checked === true) {
      setDataToSubmit([...dataToSubmit, clonedVisualizationData[index]?.id]);
    } else {
      dataToSubmit.splice(
        dataToSubmit.findIndex((e) => e === id),
        1
      );
      setDataToSubmit([...dataToSubmit]);
    }
  };
  const handleCustomInputChange = (event) => {
    const inputValue = event.target.value;
    let validatedValue = validateLowerCase(inputValue);
    validatedValue = validateNoSpecialChars(validatedValue);
    validatedValue = validateAndReplaceSpaces(validatedValue);

    setCustomInputValue(validatedValue);
  };
  const submit = () => {
    const newArray = dataToSubmit.map((dataToSubmitId) => {
      const matchingItem = selectValues.find(
        (item) => item.id === dataToSubmitId
      );

      // If a matching item is found, return an object with id and value, otherwise return null
      return matchingItem
        ? { file_id: matchingItem.id, table_name: matchingItem.value }
        : null;
    });

    dispatch(submitForVisualization(newArray));
  };
  const handleSaveCustomValue = () => {
    if (customInputValue) {
      const newMenuItem = {
        value: customInputValue,
        label: customInputValue,
      };
      setMenuItems([...menuItems, newMenuItem]);
      // setSelectValue(customInputValue);
      setCustomInputValue("");
      const data = {
        table_name: customInputValue,
        created_by: localStorage?.userName,
        user_id: localStorage.userid,
      };
      dispatch(addNewVisualizationTableName(data));
    }
  };
  const onSearch = (word, type) => {
    let result;

    if (!visualizationData || !Array.isArray(visualizationData)) {
      setClonedVisualizationData([]);
      return;
    }

    if (type === "project") {
      if (word) {
        result = visualizationData?.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
      } else {
        result = visualizationData;
      }
    } else {
      if (word) {
        const filteredBatches = visualizationData?.filter(function (el) {
          return (
            el?.batch_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
        result = filteredBatches;
      } else {
        result = visualizationData;
      }
    }
    setClonedVisualizationData(result);
  };

  return (
    <div>
      <Header />
      <Grid className="sidebar-main" container>
        <Grid item className="sidebar-container">
          <LeftSideBar page="sidebar" />
        </Grid>

        <Grid className="visualization-conatiner" item>
          <AdministratorHeader text="Data Visualization" />

          <div className="seatch-bar">
            <SearchBar onSearch={(value, type) => onSearch(value, type)} />
          </div>

          <div>
            {visualizationDataCount?.loader ? (
              <DashboardTableSkaleton count={7} />
            ) : (
              <>
                {visualizationDataCount?.loader === false &&
                clonedVisualizationData?.length > 0 ? (
                  <TableContainer className="visualization-table-container-v">
                    <Table
                      stickyHeader
                      className="table-output"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Unit Operation</TableCell>
                          <TableCell align="left">Project Name</TableCell>
                          <TableCell align="left">Batch Name</TableCell>
                          <TableCell align="left">File Name</TableCell>
                          <TableCell align="left">
                            Select For Visualization
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {clonedVisualizationData?.map((list, index) => {
                          return (
                            <>
                              <TableRow key={list?.id}>
                                <TableCell align="left">
                                  <div>
                                    {list?.selectValue !== "New" ? (
                                      <FormControl
                                        fullWidth={true}
                                        className="w-100"
                                      >
                                        {list?.selectValue === "" ||
                                          (list?.selectValue === undefined && (
                                            <InputLabel
                                              id="demo-simple-select-label"
                                              shrink={false}
                                            >
                                              Select or Enter Value
                                            </InputLabel>
                                          ))}
                                        <Select
                                          value={list.selectValue}
                                          onChange={(event) =>
                                            handleSelectChange(
                                              event,
                                              index,
                                              list
                                            )
                                          }
                                          disabled={
                                            selectedDropdownIndex !== -1 &&
                                            selectedDropdownIndex !== index
                                          }
                                        >
                                          <MenuItem value="New">New</MenuItem>
                                          {menuItems?.map((menuItem) => (
                                            <MenuItem
                                              key={menuItem.value}
                                              value={menuItem.value}
                                            >
                                              {menuItem.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    ) : (
                                      <FormControl
                                        fullWidth={true}
                                        className="w-100"
                                      >
                                        <OutlinedInput
                                          value={customInputValue}
                                          onChange={handleCustomInputChange}
                                          startAdornment={
                                            <Select
                                              className="new-select-menu"
                                              disableUnderline
                                              variant="standard"
                                              disabled={
                                                selectedDropdownIndex !== -1 &&
                                                selectedDropdownIndex !== index
                                              }
                                              value={list.selectValue}
                                              onChange={(event) =>
                                                handleSelectChange(event, index)
                                              }
                                            >
                                              {menuItems.map((menuItem) => (
                                                <MenuItem
                                                  key={menuItem.value}
                                                  value={menuItem.value}
                                                >
                                                  {menuItem.label}
                                                </MenuItem>
                                              ))}
                                              <MenuItem value="New">
                                                New
                                              </MenuItem>
                                            </Select>
                                          }
                                          endAdornment={
                                            <IconButton
                                              variant="outlined"
                                              onClick={() =>
                                                handleSaveCustomValue(index)
                                              }
                                            >
                                              <AddIcon />
                                            </IconButton>
                                          }
                                        />
                                      </FormControl>
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell align="left">
                                  {list?.project_name}
                                </TableCell>
                                <TableCell align="left">
                                  {list?.batch_name}
                                </TableCell>
                                <TableCell align="left">
                                  {list?.file_name}
                                </TableCell>
                                <TableCell align="center">
                                  {list?.status === true ? (
                                    <Checkbox
                                      checked={
                                        list?.status === true ? true : false
                                      }
                                      disabled={
                                        list?.status === true ? true : false
                                      }
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  ) : (
                                    <Checkbox
                                      onChange={(e) =>
                                        handleChange(e, index, list?.id)
                                      }
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  )}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <div className="no-data">
                    <Label
                      text="No Data Found"
                      fontSize="16"
                      fontWeight="600"
                      padding="20px"
                    />
                  </div>
                )}
              </>
            )}
          </div>

          {submitSatatus?.loader === true && <ProgressBar />}

          <Grid container>
            <Grid item sm={8}>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 500]}
                component="div"
                count={pageCount}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>

            <Grid className="submit-btn-grid" item sm={4}>
              <Button
                className="submit-btn"
                variant="contained"
                onClick={submit}
                disabled={dataToSubmit.length === 0}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )}
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </div>
  );
};
export default VisualizationDashboardTables;
